import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import AppHeader from '../components/layout/AppHeader/AppHeader.js';
import AppRoutes from './routes/AppRoutes.js';

function App() {
  return (
    <Router>
      <AppHeader />
      <div className="body-container">
        <AppRoutes />
      </div>
    </Router>
  );
}

export default App;
